<template>
    <v-card>
        <v-toolbar dark fixed color="primary">
          <v-toolbar-title>Användarvillkor</v-toolbar-title>
        </v-toolbar>
        <terms-content/>
      </v-card>
</template>

<script>
import TermsContent from '@/components/TermsContent'
export default {
  components: {
    TermsContent
  }
}
</script>
